import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { LinkBox, LinkBoxTabs } from '@seo/linkbox';
import Container from '@/components/structure/Container';
import { useTranslation } from '@/hooks/useTranslations';
import { usePrefixI18n } from '@/contexts/brandConfiguration/hooks';
import { FOOTNOTES } from '@/components/tools/footnotes';
export const LinksBox = ({ data }) => {
    var _a;
    const { t } = useTranslation();
    const prefix = usePrefixI18n();
    const locales = `${prefix}fsrbo.generic.footer`;
    return (_jsx(Box, { backgroundColor: "color.background.light", paddingTop: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.64',
        }, paddingBottom: "spacing.16", children: _jsxs(Container, { children: [data.length > 0 &&
                    (data.length > 1 ? (_jsx(LinkBoxTabs, { dataTabs: data, hasDivider: true })) : (((_a = data[0]) === null || _a === void 0 ? void 0 : _a.links) && (_jsx(Box, { marginBottom: "spacing.56", children: _jsx(LinkBox, { name: "", links: data[0].links, type: data[0].type }) })))), _jsx(Box, { typography: "typography.body.14.regular", color: "color.content.subdued.default", marginTop: "spacing.56", children: _jsx("p", { id: `${FOOTNOTES[1].ref}`, children: t(`${locales}.mention1`) }) }), _jsx(Box, { marginTop: "spacing.8", typography: "typography.body.14.regular", color: "color.content.subdued.default", children: _jsx("p", { id: `${FOOTNOTES[2].ref}`, children: t(`${locales}.mention2`) }) })] }) }));
};
